import { FadeIn } from "./FadeIn";
import { OWNER_PROFILE_IMAGE_URL } from "@/config/assets";

export const About = () => (
  <section id="about" data-testid="about-section" className="grain-overlay bg-[#FAF9F6] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
      <FadeIn>
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-full h-full border border-[#D4AF37]/50 rounded-sm" />
          <img
            src={OWNER_PROFILE_IMAGE_URL}
            alt="Paresh Patel, Owner of Leelarav Greens"
            data-testid="owner-portrait-image"
            className="relative rounded-sm object-cover w-full max-h-[80vh] shadow-[0_8px_32px_rgba(4,57,39,0.15)]"
          />
          <div className="absolute bottom-6 left-6 right-6 bg-[#043927]/85 backdrop-blur-md border border-[#D4AF37]/30 rounded-sm px-6 py-4">
            <p className="font-serif-luxe text-2xl text-[#F3E5AB]">Paresh Patel</p>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mt-1">Founder & Owner</p>
          </div>
        </div>
      </FadeIn>

      <div>
        <FadeIn>
          <p className="text-[#097969] uppercase tracking-[0.4em] text-xs mb-5">The Legacy & Leadership</p>
          <h2 className="font-serif-luxe text-4xl md:text-5xl font-medium text-[#043927] leading-tight">
            A Welcome Message <span className="italic">from the Owner</span>
          </h2>
        </FadeIn>

        {/* <!-- INSERT OWNER WELCOMING CONTENT HERE --> */}
        <FadeIn delay={0.15}>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#1A1A1A]/80 font-light">
            "Welcome to Leelarav Greens — a sanctuary where every celebration becomes a
            cherished legacy. When we opened our gates in 2022, my vision was simple yet
            profound: to craft a venue where the serenity of nature embraces the splendour
            of royal hospitality. Nestled amidst acres of manicured emerald lawns, every
            corner of our estate has been designed to make your most precious moments
            feel truly extraordinary."
          </p>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-[#1A1A1A]/80 font-light">
            "From intimate ring ceremonies to grand weddings and prestigious corporate
            galas, our devoted team treats every event as if it were our own family's
            celebration. It is my personal promise that when you walk into Leelarav
            Greens, you walk into an experience of warmth, elegance, and perfection."
          </p>
        </FadeIn>
        {/* <!-- END OWNER WELCOMING CONTENT --> */}

        <FadeIn delay={0.3}>
          <div className="mt-10 flex items-center gap-6">
            <div className="h-px flex-1 max-w-[80px] bg-[#D4AF37]" />
            <p className="font-serif-luxe italic text-xl text-[#097969]">Warm regards, Paresh Patel</p>
          </div>
        </FadeIn>
      </div>
    </div>
  </section>
);
